var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donnut-chart-section",class:{ printVersion: _vm.printVersion }},[_c('donnut-component-d3',{attrs:{"uni_color":_vm.uniColor,"data-entry":_vm.donnutData,"labels-entry":_vm.donnutLabels,"colors":_vm.colors}}),_vm._v(" "),_c('donnut-info',{attrs:{"data":_vm.infoData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01ea1444","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DonnutChartSection.vue
// module id = 1301
// module chunks = 1